module.exports = __webpack_public_path__ + "static/media/pobble-home-visual-2.fc75544c.jpg";